// Helpers for working with YouTube links pasted into the admin Vehicle Manager.
// Admins may paste any of the following into a video field and we normalize it:
//   - A full <iframe ... src="https://www.youtube.com/embed/VIDEO_ID" ...> embed
//   - https://www.youtube.com/watch?v=VIDEO_ID
//   - https://youtu.be/VIDEO_ID
//   - https://www.youtube.com/embed/VIDEO_ID
//   - https://www.youtube.com/shorts/VIDEO_ID
//   - A bare 11-character video ID

// Extract the 11-character YouTube video ID from any of the supported inputs.
// Returns null when no valid ID can be found.
export function extractYouTubeId(input) {
  if (!input || typeof input !== 'string') return null;

  const value = input.trim();
  if (!value) return null;

  // Bare 11-char video ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
    return value;
  }

  // Pull the ID out of any URL form (also matches the src="" inside an iframe)
  const patterns = [
    /youtube\.com\/watch\?(?:[^&]*&)*v=([a-zA-Z0-9_-]{11})/,
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
    /youtube-nocookie\.com\/embed\/([a-zA-Z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = value.match(pattern);
    if (match && match[1]) return match[1];
  }

  return null;
}

// Convenience: turn a raw pasted value into a privacy-friendly embed URL, or null.
export function toYouTubeEmbedUrl(input) {
  const id = extractYouTubeId(input);
  return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
}

// Convenience: thumbnail URL for the lite facade (no YouTube JS needed to show it).
export function toYouTubeThumbnail(input) {
  const id = extractYouTubeId(input);
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : null;
}
